import React from "react";
import DoctorFormPage from "../components/doctors/DoctorFormPage";

const DoctorCreate = () => <DoctorFormPage mode="create" />;

export default DoctorCreate;
